// extracted by mini-css-extract-plugin
export default {"wrapper":"single-payment_wrapper__dkE18","status":"single-payment_status__6ByrB","date":"single-payment_date__9Bv-v","name":"single-payment_name__Jo3q7"};